import {
  FETCH_TUTORIAL_LIST,
  FETCH_TUTORIAL_STEPS,
  AUTO_STEP,
  UPDATE_STEP,
  UPDATE_STEP_NB,
  ANIMATE_STEP,
  ANIMATE_ALL,
  UPDATE_FRAME,
  ANIMATE_ALL_TERM
} from './constants'

export const fetchTutorialList = {
  request: currentPhoneId => ({
    type: FETCH_TUTORIAL_LIST.REQUEST,
    currentPhoneId
  }),
  success: (currentPhoneId, tutorials) => ({
    type: FETCH_TUTORIAL_LIST.SUCCESS,
    currentPhoneId,
    tutorials
  })
}

export const fetchTutorialSteps = {
  request: tutorialId => ({
    type: FETCH_TUTORIAL_STEPS.REQUEST,
    tutorialId
  }),
  success: (tutorialId, tutorial) => ({
    type: FETCH_TUTORIAL_STEPS.SUCCESS,
    tutorialId,
    tutorial
  })
}

export const updateStep = step => ({ type: UPDATE_STEP, step })
export const updateStepNonBlocking = step => ({ type: UPDATE_STEP_NB, step })
export const playStepAnimation = () => ({ type: ANIMATE_STEP })
export const playAllStepAnimation = () => ({ type: ANIMATE_ALL })
export const termAllStepAnimation = () => ({ type: ANIMATE_ALL_TERM })
export const updateStepFrame = index => ({ type: UPDATE_FRAME, index })
export const autoStep = () => ({ type: AUTO_STEP })



// WEBPACK FOOTER //
// ./src/containers/Tutorials/actions.js